export const processData = (data) => {
    // data.splice(0,9)
    const startOfData = data.findIndex((item)=> item[0] && (item[0]).includes('This month selling:'))
    data.splice(0,startOfData+2)
    data.splice(data.length-3, 3)

    let books = []
    data.map((item, index)=>{
        if(index !== data.length-1 && item[0]){
            const singleBook = {
                title:item[0],
                authorId:item[1] || null,
                date:item[2]||null,
                profitPaperBack: item[3] || null,
                profitAmazonKindle: item[4] || null,
                paperBackAmazon:item[5] || null,
                paperBackFlipkart:item[6] || null,
                nexusStore: item[7]||null,
                paperBackTotal: item[8] || null,
                paperBackProfitEarned: item[9]||null,
                kindleOverseas: item[10]|null,
                kindleAmazonIn: item[11] || null,
                kindleTotalQty: item[12]||null,
                kindleProfitEarnings:item[13]||null,
                grandTotal: item[14] || null,
                createdAt: new Date(),
                updatedAt: new Date(),
            }
            books.push(singleBook);
        }
    })
    return books;
}

const excelDateToJSDate = (excelDate)=> {
    var date = new Date(Math.round((excelDate - (25567 + 1)) * 86400 * 1000));
    var converted_date = date.toISOString().split('T')[0];
    return converted_date;
}
export const getCummulativeData  = (data)=> {
    data.splice(0,2)
    const emptyCellIndex = data.findIndex((item)=> item.length == 0)
    let totalData = []
    data.map((item, index)=>{
        if(index < emptyCellIndex){
            const singleBook = {
                title: item[0]||null,
                authorId:item[1] || null,
                lifeTimeEarningPaperBack: item[2]||null,
                lifeTimeEarningKindle: item[3]||null,
                paperBackTotalBooksSold: item[4]||null,
                kindleTotalBooksSold: item[5]||null,
                authorCopy:item[6]||null,
                grandTotal:item[7]||null,
            }
            totalData.push(singleBook);
        }
    })
    return totalData;
}
export const processTransactionData = (data) => {
    const startOfData = data.findIndex((item)=> item[0] && (item[0]).includes('Overall Earning Status'))
    data.splice(0,startOfData+2)
    data.splice(data.length-5, 5)
    let transactions  = [];
    data.map((item, index)=>{
            const singleBook = {
                title:item[0],
                authorId:item[1] || null,
                lifeTimeEarningPaperBack: item[2] || null,
                lifeTimeEarningAmazonKindle: item[3] || null,
                totalEarning:item[4] || null,
                payable:item[5] || null,
                transactionDate: item[6]||null,
                transactionBy: item[7]|| null,
                deposit: item[8]|| null,
                balance: item[9]|| null,
                remarks: item[10]|| null,
                createdAt: new Date(),
                updatedAt: new Date(),
            }
            transactions.push(singleBook);
    })
    return transactions;
}
